/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DateTimeBetween
 */
export interface DateTimeBetween {
    /**
     * 
     * @type {Date}
     * @memberof DateTimeBetween
     */
    fromInclusive?: Date;
    /**
     * 
     * @type {Date}
     * @memberof DateTimeBetween
     */
    toInclusive?: Date;
}

/**
 * Check if a given object implements the DateTimeBetween interface.
 */
export function instanceOfDateTimeBetween(value: object): value is DateTimeBetween {
    return true;
}

export function DateTimeBetweenFromJSON(json: any): DateTimeBetween {
    return DateTimeBetweenFromJSONTyped(json, false);
}

export function DateTimeBetweenFromJSONTyped(json: any, ignoreDiscriminator: boolean): DateTimeBetween {
    if (json == null) {
        return json;
    }
    return {
        
        'fromInclusive': json['fromInclusive'] == null ? undefined : (new Date(json['fromInclusive'])),
        'toInclusive': json['toInclusive'] == null ? undefined : (new Date(json['toInclusive'])),
    };
}

export function DateTimeBetweenToJSON(value?: DateTimeBetween | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fromInclusive': value['fromInclusive'] == null ? undefined : ((value['fromInclusive']).toISOString()),
        'toInclusive': value['toInclusive'] == null ? undefined : ((value['toInclusive']).toISOString()),
    };
}

